import type { QueryOptions } from '@apollo/client';

import type { Extension } from './graphql/types';
import { transformPreFilteredExtensions } from './hooks/lib/transformForgeExtensions';
import type {
	PreFilteredExtensionsQueryOptions,
	PrefilteredExtensionsResult,
	UsePreFilteredExtensionsQueryOptions,
} from './hooks/usePrefilteredExtensionList';
import { createUsePrefilteredExtensionListQueryOptions } from './hooks/usePrefilteredExtensionList';
import { FetchPreFilteredForgeAppsQuery } from './hooks/lib/queries';

export const preloadPrefilteredExtensionList = async <T>(
	query: <T, V>(options: QueryOptions<V>) => Promise<{ data: T | null }>,
	{
		cloudId,
		context,
		includeHidden,
		locale,
		types,
		client,
		queryOptions,
	}: UsePreFilteredExtensionsQueryOptions,
) => {
	if (!client) {
		return null;
	}

	const requestOptions =
		createUsePrefilteredExtensionListQueryOptions<PreFilteredExtensionsQueryOptions>(
			cloudId,
			context,
			client,
			types,
			locale,
			includeHidden,
			queryOptions,
		);

	const { data } = await query<PrefilteredExtensionsResult, PreFilteredExtensionsQueryOptions>({
		query: FetchPreFilteredForgeAppsQuery,
		variables: requestOptions,
	});

	const extensions = (data?.confluence_forgeExtensionsByType || []) as Extension[];
	if (extensions.length > 0) {
		return transformPreFilteredExtensions(extensions);
	}
	return null;
};
